// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "card__icon-2wx9U";
export { _1 as "__esModule", _2 as "card__icon" }
export default { "__esModule": _1, "card__icon": _2 }
